import { Toaster } from '@geneui/components';

import { useTranslator } from 'utils/translator';

const useCopyToClipboard = () => {
  const { t } = useTranslator();

  const copyToClipboard = async value => {
    const iconProps = {
      isFilled: true,
    };
    if (!navigator.clipboard) {
      const input = document.createElement('input');
      input.value = value;
      document.body.appendChild(input);
      input.select();

      document.execCommand('copy')
        ? Toaster.success({ title: t('copied'), message: value, iconProps })
        : Toaster.error({ title: t('error'), message: '', iconProps });

      document.body.removeChild(input);
    } else {
      try {
        await navigator.clipboard.writeText(value);
        Toaster.success({ title: t('copied'), message: value, iconProps });
      } catch (e) {
        Toaster.error({ title: t('error'), message: '', iconProps });
      }
    }
  };

  const copyToClipboardWithPromise = async promise => {
    const iconProps = {
      isFilled: true,
    };

    try {
      const clipboard = new window.ClipboardItem({
        'text/plain': promise,
      });
      await navigator.clipboard.write([clipboard]);
      const value = await promise;
      Toaster.success({ title: t('copied'), message: value, iconProps });
    } catch (error) {
      Toaster.error({ title: t('error'), message: error, iconProps });
    }
  };

  return { copyToClipboard, copyToClipboardWithPromise };
};

export default useCopyToClipboard;
